import { render, staticRenderFns } from "./tocco-event-search-testing.vue?vue&type=template&id=581a176e"
import script from "./tocco-event-search-testing.vue?vue&type=script&lang=ts"
export * from "./tocco-event-search-testing.vue?vue&type=script&lang=ts"
import style0 from "./tocco-event-search-testing.vue?vue&type=style&index=0&id=581a176e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports